import { type Response, sendGet, sendPost } from '../hooks/use-fetch'
import type { AddOrEditAnnualPlanMeetingRequest, TrackAnnualPlanMeetingRequest } from '../models/requestObjects/AnnualPlanRequestObjects'
import type { AnnualPlanMeeting } from '../models/AnnualPlanMeeting'

const BASE_URL = 'MeetingSchedule'

export async function AddMeeting (meeting: AddOrEditAnnualPlanMeetingRequest): Promise<Response> {
  return await sendPost(`${BASE_URL}/Add`, meeting)
}

export async function UpdateMeeting (meeting: AddOrEditAnnualPlanMeetingRequest): Promise<Response> {
  return await sendPost(`${BASE_URL}/Update`, meeting)
}

export async function TrackMeeting (request: TrackAnnualPlanMeetingRequest): Promise<Response> {
  return await sendPost(`${BASE_URL}/Track`, request)
}

export async function DeleteMeeting (meetingId: number, isUpdate: boolean): Promise<Response> {
  return await sendPost(`${BASE_URL}/Delete?meetingId=${meetingId}&isUpdate=${String(isUpdate)}`, {})
}

export async function GetAnnualPlanMeetings (annualPlanId: number, orgId: number, contractOnly: boolean): Promise<AnnualPlanMeeting[]> {
  const { response } = await sendGet(`${BASE_URL}/Get?annualPlanId=${annualPlanId}&orgId=${orgId}&contractOnly=${String(contractOnly)}`)
  return response
}
